require('./bootstrap');
window.plupload = require('plupload');

window.persianDate = require('persian-date');
require('persian-datepicker/dist/js/persian-datepicker.min');


$(function () {
    window.addEventListener('sweetAlert', function (e) {

        Swal.fire({
            title: e.detail.title,
            icon: e.detail.icon,
            toast: true,
            showConfirmButton: false,
            position: 'top-right',
            timer: 3000
        });


    });
    window.addEventListener('urlChange', function (e) {

        history.pushState(null, null, e.detail);

    });

    window.addEventListener('tooltip', function (e) {
        $('[data-toggle="tooltip"]').tooltip()
    });
    pDatePicker()

    function pDatePicker() {
        $('.pDatePicker').persianDatepicker({
            format: 'YYYY/MM/DD',
            viewMode: "year",
            responsive: true,
            autoClose: true,
            initialValueType: 'gregorian',
            altField: '.alt-field-example-alt-field',
            toolbox: {
                enabled: false,
            },
            persian: {
                locale: "fa",
                showHint: true,
                leapYearMode: "algorithmic"
            },
            gregorian: {
                locale: "en",
                showHint: true
            },
            dayPicker: {
                titleFormat: 'YYYY/MM/DD',

                onSelect: function (unix) {
                    var date = new Date(unix);

                    Livewire.emit('getDate', [
                        date.getFullYear(), date.getMonth() + 1, date.getDate()
                    ])
                }
            }

        });
    }

    setNavigation()

    function setNavigation() {
        let path = window.location.href;

        path = path.replace(/\/$/, "");
        path = decodeURIComponent(path);
        $(".nav-header a").each(function () {
            let href = $(this).attr('href')

            if (path === href) {
                $(this).closest('a').addClass('active');
                $(this).closest('a').removeClass('text-muted');
            }
        });

        $(".sidenav  a").each(function () {
            let href = $(this).attr('href')

            if (path.substring(0, href.length) === href) {
                $(this).closest('a').addClass('active');
                $(this).closest('a').removeClass('text-muted');
            }
        });
    }

    window.addEventListener('closeModal', function (e) {
        $('#' + e.detail).modal('hide');
    })

    window.addEventListener('overflow', function (e) {

        if (e.detail[0] === 'stop') {
            $('.card-fixed').addClass('stop-scrolling')

        } else if (e.detail[0] === 'start') {
            $('.card-fixed').removeClass('stop-scrolling')

        }

    })
    window.addEventListener('scrollLoad', function (e) {

        $('.card-fixed').on('scroll', function () {

            let div = $(this).get(0);
            if (div.scrollTop + div.clientHeight >= div.scrollHeight) {
                window.livewire.emit('loadMore');

            }


        });
    })

    window.addEventListener('openModal', function (e) {
        $('#' + e.detail).modal('show');
        $('.card-fixed').addClass('stop-scrolling')
    })
    $(document).ready(function () {
        $('.nav-link-collapse').on('click', function () {
            $('.nav-link-collapse').not(this).removeClass('nav-link-show');
            $(this).toggleClass('nav-link-show');
        });
    });
    window.addEventListener('select2', function (e) {
        $('.js-example-basic-multiple').select2();
    });
});
